// 请求cookie键名
const Authorizition = 'accessToken'
// 会话过期错误码
const TOKEN_EXPIRED_CODE = 10001;

const domain = window.location.origin;
// 接口baseURL
const baseUrl = process.env.BUILD_ENV === 'local' ? '/api' : `${domain}/common_gw/`;
const httpUrl = `${domain}/activityManagerPC`;

const numberCompareEnum = {
  greater: '>',        // 大于
  less: '<',           // 小于
  equal: '=',          // 等于
  greaterOrEqual: '>=', // 大于等于
  lessOrEqual: '<=',    // 小于等于
  notEqual: '!=',       // 不等于
  range: 'between'          // 介于A-B
}

export { Authorizition, baseUrl, httpUrl, TOKEN_EXPIRED_CODE, numberCompareEnum }
